// @waveops/locales — shared i18n bundles for LawnOps + WaveOps.

import enCommon from "./en/common.json";
import enAuth from "./en/auth.json";
import enDashboard from "./en/dashboard.json";
import enQuote from "./en/quote.json";
import enLeads from "./en/leads.json";
import enCustomers from "./en/customers.json";
import enProperties from "./en/properties.json";
import enServices from "./en/services.json";
import enBilling from "./en/billing.json";
import enPool from "./en/pool.json";
import enLawn from "./en/lawn.json";

import esCommon from "./es/common.json";
import esAuth from "./es/auth.json";
import esDashboard from "./es/dashboard.json";
import esQuote from "./es/quote.json";
import esLeads from "./es/leads.json";
import esCustomers from "./es/customers.json";
import esProperties from "./es/properties.json";
import esServices from "./es/services.json";
import esBilling from "./es/billing.json";
import esPool from "./es/pool.json";
import esLawn from "./es/lawn.json";

export const en = {
  common: enCommon,
  auth: enAuth,
  dashboard: enDashboard,
  quote: enQuote,
  leads: enLeads,
  customers: enCustomers,
  properties: enProperties,
  services: enServices,
  billing: enBilling,
  pool: enPool,
  lawn: enLawn,
} as const;

export const es = {
  common: esCommon,
  auth: esAuth,
  dashboard: esDashboard,
  quote: esQuote,
  leads: esLeads,
  customers: esCustomers,
  properties: esProperties,
  services: esServices,
  billing: esBilling,
  pool: esPool,
  lawn: esLawn,
} as const;

export const resources = { en, es } as const;

export const supportedLocales = ["en", "es"] as const;
export type SupportedLocale = (typeof supportedLocales)[number];

export const localeNames: Record<SupportedLocale, string> = {
  en: "English",
  es: "Español",
};

export const namespaces = [
  "common",
  "auth",
  "dashboard",
  "quote",
  "leads",
  "customers",
  "properties",
  "services",
  "billing",
  "pool",
  "lawn",
] as const;

export type Namespace = (typeof namespaces)[number];
